!((document, Drupal, $) => {
  'use strict';

  var MOBILE_BREAKPOINT = 1024;

  /**
   * Creates behavior for main menu to allow for open/close functionality.
   */
  Drupal.behaviors.mainNavigation = {
    attach: function(context) {
      /**
       * Bind open/close action to list containers.
       * @param {string} menu - Menu or menu-item container.
       * @param {string} activeElement - Current active element.
       * @param {string} button - Menu item buttons.
       * @param {context} context - Drupal context.
       * @returns {void}
       */
      function mainNavigation(menu, activeElement, button, context) {
        const $menu = $(menu, context);
        const $activeElement = $(activeElement + menu, context);
        const $button = $menu.find(button);

        $menu.each(function() {
          const $navigation = $(this);

          $navigation.find(button).on('click', function() {
            const $self = $(this);
            // Removes the 'is-expanded' class from all menus
            // except the one we are currently clicking on.
            $menu.not($navigation).removeClass('is-expanded');

            // Toggles 'is-expanded' class on menu or menu-item
            // we are clicking on.
            $navigation.toggleClass('is-expanded');

            $button.not($self).attr('aria-expanded', 'false');

            // Updates 'aria-expanded' attribute value based on
            // menu state (open/closed).
            if ($self.attr('aria-expanded') === 'true') {
              $self.attr('aria-expanded', 'false');
            }
            else {
              $self.attr('aria-expanded', 'true');
            }
          });

          $navigation.on('mouseenter', function() {
            if (window.innerWidth < MOBILE_BREAKPOINT) {
              return;
            }
            const $self = $(this);
            // Removes the 'is-expanded' class from all menus
            // except the one we are currently clicking on.
            $menu.not($navigation).removeClass('is-expanded is-overflow');

            $menu
              .not($self)
              .find(button)
              .attr('aria-expanded', 'false');

            // If the item has no submenu, it ends the function
            if ($self.hasClass('navigation__item--no-submenu')) {
              return;
            }

            // Toggles 'is-expanded' class on menu or menu-item
            // we are clicking on.
            $navigation.addClass('is-expanded');
            $self.find(button).attr('aria-expanded', 'true');

            // Check if the menu is overflowing the viewport.
            const $elm = $('ul:first', this);
            const off = $elm.offset();
            const l = off.left;
            const w = $elm.width();
            const docW = $('.navigation--top-wrapper', context).width();

            const isEntirelyVisible = (l + w <= docW);

            if (!isEntirelyVisible) {
              $navigation.addClass('is-overflow');
            }
          });
        });

        $('.navigation--top-wrapper', context).on('mouseleave', function() {
          if (window.innerWidth < MOBILE_BREAKPOINT) {
            return;
          }
          // Removes the 'is-expanded' class from all menus
          // except the one we are currently clicking on.
          $menu.not($activeElement).removeClass('is-expanded');

          // Toggles 'is-expanded' class on menu or menu-item
          // we are clicking on.
          $activeElement.addClass('is-expanded');

          // Updates 'aria-expanded' attribute value based on
          // menu state (open/closed).
          $menu
            .not($activeElement)
            .find(button)
            .attr('aria-expanded', 'false');

          $activeElement.find(button).attr('aria-expanded', 'true');
        });

        // Detect when focus is triggered on each top level
        // menu item and remove `is-expanded` class from
        // all other top level menu items.  This will ensure
        // the previously-opened top level dropdown will collapse
        // and thus inheriting default styles.
        // $topMenu.each(function () {
        //   const $topMenuItem = $(this);

        //   $topMenuItem.focus(function () {
        //     // Collapse opened dropdowns when focus is triggered on
        //     // another dropdown in the top menu.
        //     $topMenu.not($topMenuItem).removeClass('is-expanded');

        //     // Make link unfocusable to prevent two focus events;
        //     // one on the list item and the other in the child link.
        //     $topMenu.children('a:first-child').attr('tabindex', '-1');
        //   });

        //   // When there are no extra top level menu items to
        //   // set focus on (after releasing focus from last menu item),
        //   // use the 'focusout' event to collapse last
        //   // top level dropdown.  Not doing this leaves the last
        //   // parent dropdown with 'is-expanded' class and therefore
        //   // styles don't apply properly.
        //   $topMenu
        //     .find('li')
        //     .last()
        //     .on('focusout', function () {
        //       $topMenuItem.removeClass('is-expanded');
        //     });
        // });
      }

      // Bind the function to the parent menu.
      mainNavigation(
        '.navigation__item--level-1',
        '.navigation__item--active-trail',
        '.navigation__toggle',
        context
      );

      // Adds click event for mobile menu toggle.
      const $navigationToggle = $('.navigation__mobile', context);
      $navigationToggle.on('click', function() {
        const $aria = $('.navigation__mobile-show');
        $('.navigation--top-wrapper', context).toggleClass('is-mobile-open');
        $('.navigation__item--level-1', context).removeClass('is-expanded');

        // Toggles aria-expanded attribute value true/false.
        if ($aria.attr('aria-expanded') === 'true') {
          $aria.attr('aria-expanded', 'false');
        }
        else {
          $aria.attr('aria-expanded', 'true');
        }
      });

      // Adds click event for mobile search button.
      const $searchToggle = $('.header__mobile--search', context);
      $searchToggle.on('click', function() {
        const $self = $(this);
        document.body.classList.toggle('search--is-active');
        // Toggles aria-expanded attribute value true/false.
        if ($self.attr('aria-expanded') === 'true') {
          $self.attr('aria-expanded', 'false');
        }
        else {
          $self.attr('aria-expanded', 'true');
        }
      });

      // Main menu keyboard arrow keys access.
      $('.menu-item--level-0 a, .menu-item--has-submenu button').keydown(
        function(e) {
          // eslint-disable-line max-len
          // Listen for the up, down, left and right arrow keys,
          // otherwise, end here
          if ([37, 38, 39, 40].indexOf(e.keyCode) === -1) {
            return;
          }
          var link = $(this);

          switch (e.keyCode) {
            case 37: // Left arrow
              if (
                link
                  .parent('li')
                  .prevAll('li')
                  .filter(':visible')
                  .first().length === 0 &&
                !link.hasClass('menu-item-toggle')
              ) {
                // eslint-disable-line max-len
                // Focus on the last item in the top level
                link
                  .parent('li')
                  .nextAll('li')
                  .filter(':visible')
                  .last()
                  .find('a')
                  .first()
                  .focus(); // eslint-disable-line max-len
              }
              else {
                if (
                  link
                    .parent('li')
                    .prev('li')
                    .find('button')
                    .hasClass('menu-item-toggle') &&
                  !link.hasClass('menu-item-toggle')
                ) {
                  // eslint-disable-line max-len
                  link
                    .parent('li')
                    .prev('li')
                    .find('button')
                    .focus();
                }
                else if (link.hasClass('menu-item-toggle')) {
                  link.prev('a').focus();
                }
                else {
                  link
                    .parent('li')
                    .prevAll('li')
                    .filter(':visible')
                    .first()
                    .find('a')
                    .first()
                    .focus(); // eslint-disable-line max-len
                }
              }
              break;
            case 38: // Up arrow
              e.preventDefault();
              e.stopPropagation();
              if (link.parent('li').prev('li').length === 1) {
                link
                  .parent('li')
                  .prev('li')
                  .find('a')
                  .focus();
              }
              else {
                if (
                  link
                    .parents('ul.main-menu__sub-menu')
                    .prev('button')
                    .hasClass('menu-item-toggle')
                ) {
                  // eslint-disable-line max-len
                  link
                    .parents('ul.main-menu__sub-menu')
                    .prev('button')
                    .focus();
                }
                else {
                  link
                    .parent('li')
                    .prevAll('li')
                    .filter(':visible')
                    .first()
                    .find('a')
                    .first()
                    .focus(); // eslint-disable-line max-len
                }
              }
              break;
            case 39: // Right arrow
              if (
                link
                  .parent('li')
                  .nextAll('li')
                  .filter(':visible')
                  .first().length === 0 &&
                link.next('button').length === 0
              ) {
                // eslint-disable-line max-len
                link
                  .parent('li')
                  .prevAll('li')
                  .filter(':visible')
                  .last()
                  .find('a')
                  .first()
                  .focus(); // eslint-disable-line max-len
              }
              else {
                if (link.next('button').length === 1) {
                  link.next('button').focus();
                }
                else {
                  link
                    .parent('li')
                    .nextAll('li')
                    .filter(':visible')
                    .first()
                    .find('a')
                    .first()
                    .focus(); // eslint-disable-line max-len
                }
              }
              break;
            case 40: // Down arrow.
              e.preventDefault();
              e.stopPropagation();
              if (link.hasClass('menu-item-toggle')) {
                link
                  .next('.menu')
                  .first()
                  .find('a')
                  .first()
                  .focus();
              }
              else {
                link
                  .parent('li')
                  .nextAll('li')
                  .filter(':visible')
                  .first()
                  .find('a')
                  .first()
                  .focus(); // eslint-disable-line max-len
              }
              break;
          }
        }
      );
    }
  };
})(document, Drupal, jQuery);
